import React from 'react';
import QQpet from 'assets/PetIcon/normal/01-256.ico';
import QQpetstudy from 'assets/PetIcon/study/study.gif';
import QQpetwork from 'assets/PetIcon/work/work.gif';
import './css/menu.css';
import before from 'assets/PetMenu/ditu04.png';
import after from 'assets/PetMenu/ditu04_2.bmp';
import submenu from 'assets/PetMenu/ditu06_01.png';
import submenu1 from 'assets/PetMenu/ditu06_02.png';
import PetProfile from './PetProfile';

class QQPetFooter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Subvisible: false,
      visible: false,
      left: 0,
      top: 0,
      data: [1, 1, 1, 1, 1, 1],
      data1: [1, 1, 1, 1, 1],
      profile: [0, 0], //visible, hover
      QQpet: QQpet,
    };
    this.myRef = React.createRef();
    this.exitpet = React.createRef();
    this.profile = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('contextmenu', this._handleContextMenu);
    document.addEventListener('click', this._handleClickMenu);
    document.addEventListener('click', this.clickProfile);
  }

  hiddenSubMenu = () => {
    this.setState({ visible: false, Subvisible: false });
  };

  study = () => {
    this.setState({ QQpet: QQpetstudy });
  };
  work = () => {
    this.setState({ QQpet: QQpetwork });
  };
  normal = () => {
    this.setState({ QQpet: QQpet });
  };

  _handleClickMenu = event => {
    const { visible } = this.state;
    if (visible) {
      if (
        event.clientX <= this.state.left ||
        event.clientX >= this.state.left + 70 ||
        event.clientY <= this.state.top ||
        event.clientY >= this.state.top + 112
      ) {
        setTimeout(this.hiddenSubMenu, 300);
      }
    }
  };

  _handleContextMenu = event => {
    event.preventDefault();
    if (event.target === this.myRef.current) {
      this.setState({ visible: true });
      const clickX = event.clientX;
      const clickY = event.clientY;
      const screenW = window.innerWidth;
      const screenH = window.innerHeight;
      const rootW = this.root.offsetWidth;
      const rootH = this.root.offsetHeight;
      const right = screenW - clickX > rootW;
      const left = !right;
      const top = screenH - clickY > rootH;
      const bottom = !top;
      if (right) {
        this.root.style.left = `${clickX + 5}px`;
        this.setState({ left: clickX + 5 });
      }
      if (left) {
        this.root.style.left = `${clickX - 0.3 * rootW - 5}px`;
        this.setState({ left: clickX - 0.3 * rootW - 5 });
      }
      if (top) {
        this.root.style.top = `${clickY + 5}px`;
        this.setState({ top: clickY + 5 });
      }
      if (bottom) {
        this.root.style.top = `${clickY - rootH - 5}px`;
        this.setState({ top: clickY - rootH - 5 });
      }
    }
  };

  Menu_exitPet = () => {
    this.props.petfunc();
    this.setState({ visible: false });
  };

  clickProfile = event => {
    if (event.target === this.myRef.current) {
      this.setState({ profile: [1, 0] });
      const clickX = event.clientX;
      const clickY = event.clientY;
      const screenW = window.innerWidth;
      const screenH = window.innerHeight;
      const rootW = this.profile.current.offsetWidth;
      const rootH = this.profile.current.offsetHeight;
      const right = screenW - clickX > rootW;
      const left = !right;
      const top = screenH - clickY > rootH;
      const bottom = !top;
      if (right) {
        this.profile.current.style.left = `${clickX + 5}px`;
      }
      if (left) {
        this.profile.current.style.left = `${clickX - rootW - 5}px`;
      }
      if (top) {
        this.profile.current.style.top = `${clickY + 5}px`;
      }
      if (bottom) {
        this.profile.current.style.top = `${clickY - rootH - 5 + 10}px`;
      }
      document.removeEventListener('click', this.clickProfile);
      setTimeout(this.checkProfile_hover, 1000);
    }
  };

  checkProfile_hover = () => {
    if (this.state.profile[0] && !this.state.profile[1]) {
      this.setState({ profile: [0, 0] });
      document.addEventListener('click', this.clickProfile);
    } else setTimeout(this.checkProfile_hover, 1000);
  };

  more = () => {
    this.setState({
      data: [1, 0, 1, 1, 1, 1],
      Subvisible: true,
    });
  };

  render() {
    return (
      <div>
        {this.state.profile[0] ? (
          <PetProfile
            refpath={this.profile}
            MouseOver={() => this.setState({ profile: [1, 1] })}
            MouseLeave={() => this.setState({ profile: [1, 0] })}
          />
        ) : null}
        {this.props.show ? (
          <img
            ref={this.myRef}
            className="footer__Pet"
            style={{ height: `15px`, width: `15px` }}
            src={this.state.QQpet}
            alt=""
          />
        ) : null}
        {this.state.visible || this.state.Subvisible ? (
          <div
            ref={ref => {
              this.root = ref;
            }}
            className="contextMenu"
          >
            <div className="hi-start">
              <div className="pre-start"></div>
              <div className="contextMenu-start"></div>
              <div className="bhd-start"></div>
            </div>
            <div className="hi">
              <div
                className="pre-menu"
                style={{
                  backgroundImage: `url(${
                    this.state.data[0] === 1 ? before : after
                  })`,
                }}
              ></div>
              <div className="contextMenu-option">
                <div
                  className="option"
                  onMouseEnter={() =>
                    this.setState({ data: [0, 1, 1, 1, 1, 1],
                      Subvisible: false, })
                  }
                  onMouseLeave={()=>
                    this.setState({ data: [1, 1, 1, 1, 1, 1] })
                  }
                  onClick={() => alert(`很遗憾〒▽〒，作者没有相关素材！`)}
                >
                  宠物社区
                </div>
              </div>
              <div className="bhd-menu"></div>
            </div>
            <div className="hi">
              <div
                className="pre-menu"
                style={{
                  backgroundImage: `url(${
                    this.state.data[1] === 1 ? before : after
                  })`,
                }}
              ></div>
              <div className="contextMenu-option">
                <div
                  className="option"
                  onMouseEnter={this.more}
                  onMouseLeave={() =>
                    this.setState({
                      data: [1, 1, 1, 1, 1, 1]
                    })
                  }
                >
                  喂养宠物
                </div>
              </div>
              <div
                style={{
                  width: `29px`,
                  height: `19px`,
                  backgroundImage: `url(${
                    this.state.data[1] === 1 ? submenu : submenu1
                  })`,
                  backgroundRepeat: `no-repeat`,
                  float: `left`,
                }}
              ></div>
            </div>
            <div className="hi">
              <div
                className="pre-menu"
                style={{
                  backgroundImage: `url(${
                    this.state.data[2] === 1 ? before : after
                  })`,
                }}
              ></div>
              <div className="contextMenu-option">
                <div
                  className="option"
                  onMouseEnter={() =>
                    this.setState({ data: [1, 1, 0, 1, 1, 1],
                      Subvisible: false, })
                  }
                  onMouseLeave={()=>
                    this.setState({ data: [1, 1, 1, 1, 1, 1] })
                  }
                  onClick={() => alert(`很遗憾〒▽〒，作者没有相关素材！`)}
                >
                  好友交互
                </div>
              </div>
              <div className="bhd-menu"></div>
            </div>
            <div className="hi">
              <div
                className="pre-menu"
                style={{
                  backgroundImage: `url(${
                    this.state.data[3] === 1 ? before : after
                  })`,
                }}
              ></div>
              <div className="contextMenu-option">
                <div
                  className="option"
                  onMouseEnter={() =>
                    this.setState({ data: [1, 1, 1, 0, 1, 1],
                      Subvisible: false, })
                  }
                  onMouseLeave={() =>
                    this.setState({ data: [1, 1, 1, 1, 1, 1] })
                  }
                  onClick={() => alert(`很遗憾〒▽〒，作者没有相关素材！`)}
                >
                  粉钻特权
                </div>
              </div>
              <div className="bhd-menu"></div>
            </div>
            <div className="hi">
              <div
                className="pre-menu"
                style={{
                  backgroundImage: `url(${
                    this.state.data[4] === 1 ? before : after
                  })`,
                }}
              ></div>
              <div className="contextMenu-option">
                <div
                  className="option"
                  onMouseEnter={() =>
                    this.setState({ data: [1, 1, 1, 1, 0, 1],
                      Subvisible: false, })
                  }
                  onMouseLeave={()=>
                    this.setState({ data: [1, 1, 1, 1, 1, 1] })
                  }
                  onClick={() => alert(`很遗憾〒▽〒，作者没有相关素材！`)}
                >
                  设置帮助
                </div>
              </div>
              <div className="bhd-menu"></div>
            </div>
            <div className="hi">
              <div
                className="pre-menu"
                style={{
                  backgroundImage: `url(${
                    this.state.data[5] === 1 ? before : after
                  })`,
                }}
              ></div>
              <div className="contextMenu-option">
                <div
                  className="option"
                  onMouseEnter={() =>
                    this.setState({ data: [1, 1, 1, 1, 1, 0],
                      Subvisible: false, })
                  }
                  onMouseLeave={()=>
                    this.setState({ data: [1, 1, 1, 1, 1, 1] })
                  }
                  onClick={this.Menu_exitPet}
                >
                  退出宠物
                </div>
              </div>
              <div className="bhd-menu"></div>
            </div>
            <div className="hi-end">
              <div className="pre-end"></div>
              <div className="contextMenu-end"></div>
              <div className="bhd-end"></div>
            </div>
          </div>
        ) : null}
        {this.state.Subvisible ? (
          <div
            style={{
              top: `${
                this.state.top <= 40 ? this.state.top : this.state.top - 40
              }px`,
              left: `${
                this.state.left <= 90 ? this.state.left : this.state.left - 90
              }px`,
            }}
            className="contextMenu"
          >
            <div className="hi-start">
              <div className="pre-start"></div>
              <div
                className="contextMenu-start"
                style={{ width: `50px` }}
              ></div>
              <div className="bhd-start"></div>
            </div>
            <div className="hi">
              <div
                className="pre-menu"
                style={{
                  backgroundImage: `url(${
                    this.state.data1[0] === 1 ? before : after
                  })`,
                }}
              ></div>
              <div className="contextMenu-option">
                <div
                  className="option"
                  onMouseOver={() =>
                    this.setState({ data1: [0, 1, 1, 1, 1, 1] })
                  }
                  onMouseLeave={() =>
                    this.setState({ data1: [1, 1, 1, 1, 1, 1] })
                  }
                  onClick={this.props.feed}
                >
                  喂食
                </div>
              </div>
              <div className="bhd-menu"></div>
            </div>
            <div className="hi">
              <div
                className="pre-menu"
                style={{
                  backgroundImage: `url(${
                    this.state.data1[1] === 1 ? before : after
                  })`,
                }}
              ></div>
              <div className="contextMenu-option">
                <div
                  className="option"
                  onMouseOver={() =>
                    this.setState({ data1: [1, 0, 1, 1, 1, 1] })
                  }
                  onMouseLeave={() =>
                    this.setState({ data1: [1, 1, 1, 1, 1, 1] })
                  }
                  onClick={this.props.clean}
                >
                  清洁
                </div>
              </div>
              <div className="bhd-menu"></div>
            </div>
            <div className="hi">
              <div
                className="pre-menu"
                style={{
                  backgroundImage: `url(${
                    this.state.data1[2] === 1 ? before : after
                  })`,
                }}
              ></div>
              <div className="contextMenu-option">
                <div
                  className="option"
                  onMouseOver={() =>
                    this.setState({ data1: [1, 1, 0, 1, 1, 1] })
                  }
                  onMouseLeave={() =>
                    this.setState({ data1: [1, 1, 1, 1, 1, 1] })
                  }
                  onClick={this.props.medicine}
                >
                  看病
                </div>
              </div>
              <div className="bhd-menu"></div>
            </div>
            <div className="hi">
              <div
                className="pre-menu"
                style={{
                  backgroundImage: `url(${
                    this.state.data1[3] === 1 ? before : after
                  })`,
                }}
              ></div>
              <div className="contextMenu-option">
                <div
                  className="option"
                  onMouseOver={() =>
                    this.setState({ data1: [1, 1, 1, 0, 1, 1] })
                  }
                  onMouseLeave={() =>
                    this.setState({ data1: [1, 1, 1, 1, 1, 1] })
                  }
                  onClick={this.props.study}
                >
                  学习
                </div>
              </div>
              <div className="bhd-menu"></div>
            </div>
            <div className="hi">
              <div
                className="pre-menu"
                style={{
                  backgroundImage: `url(${
                    this.state.data1[4] === 1 ? before : after
                  })`,
                }}
              ></div>
              <div className="contextMenu-option">
                <div
                  className="option"
                  onMouseOver={() =>
                    this.setState({ data1: [1, 1, 1, 1, 0, 1] })
                  }
                  onMouseLeave={() =>
                    this.setState({ data1: [1, 1, 1, 1, 1, 1] })
                  }
                  onClick={this.props.work}
                >
                  打工
                </div>
              </div>
              <div className="bhd-menu"></div>
            </div>
            <div className="hi-end">
              <div className="pre-end"></div>
              <div className="contextMenu-end" style={{ width: `50px` }}></div>
              <div className="bhd-end"></div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
export default QQPetFooter;
